import { defineComponent as m, toRefs as g, createElementBlock as n, createCommentVNode as f, openBlock as r, unref as e, Fragment as b, renderList as S, withModifiers as h, normalizeClass as p, renderSlot as v } from "vue";
import { b as x, u as c, I as _, c as I, _ as y } from "./main-gkH8anpp.mjs";
const M = ["id", "data-cnstrc-item-section", "data-cnstrc-item-name", "aria-selected", "onMouseover", "onMousedown"], k = /* @__PURE__ */ m({
  __name: "SearchListbox",
  props: {
    suggestions: {
      type: Array,
      required: !0
    },
    c9rSection: {
      type: String,
      default: null
    }
  },
  setup(s) {
    const l = s, {
      listboxActiveIndex: a
    } = g(x);
    return (u, i) => s.suggestions.length > 0 ? (r(), n("ul", {
      key: 0,
      id: "gnav-suggestion-list",
      "aria-label": "Search Suggestions",
      role: "listbox",
      class: "search-listbox",
      onMouseleave: i[0] || (i[0] = (t) => e(c)(e(_), 0))
    }, [(r(!0), n(b, null, S(s.suggestions, (t, o) => (r(), n("li", {
      id: `autosuggest-result-${o}`,
      key: t.key,
      "data-cnstrc-item-section": l.c9rSection,
      "data-cnstrc-item-name": t.term,
      role: "option",
      class: p(["search-listbox__list-item", {
        "search-listbox__list-item--active search-term": o === e(a)
      }]),
      "aria-selected": o === e(a),
      onMouseover: (d) => e(c)(o, s.suggestions.length),
      onMousedown: h((d) => e(I)(t.term), ["left"])
    }, [v(u.$slots, "default", {
      item: t
    }, void 0, !0)], 42, M))), 128))], 32)) : f("", !0);
  }
}), C = /* @__PURE__ */ y(k, [["__scopeId", "data-v-c622f0ba"]]);
export {
  C as S
};
